// components/Toolbar/tools/SelectTool.js
import React, { useCallback, useEffect } from 'react';
import Button from './Toolbar/Button';
import { connect } from 'react-redux';
import DeleteIcon from '../images/Icon20_Delete.svg';
import * as _ from 'lodash';
import {
  hideAlertbox,
  showAlertbox,
} from '../../../redux/actions/general/alertbox';
import { __ } from '../../../core/utils';
import { setToolbarOptionsPanel } from '../../../redux/actions/fabric_overlay';

const Delete = ({
  fabric_overlay: { fabricOverlay, activeObject },
  onSubmit,
}) => {
  const handleDelete = () => {
    setToolbarOptionsPanel('');

    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description: __('plan_version_preview.alert.delete_confirmation'),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('general.alert.yes-delete'),
          onClick: () => {
            const canvas = fabricOverlay.fabricCanvas();
            const discardActiveObject = canvas.getActiveObject(); // koristi ono što je zaista aktivno

            if (!discardActiveObject) return;

            canvas.discardActiveObject();

            if (discardActiveObject.type === 'activeSelection') {
              discardActiveObject.getObjects().forEach((obj) => {
                canvas.remove(obj);
              });
            } else {
              canvas.remove(discardActiveObject);
            }

            canvas.requestRenderAll();

            onSubmit(fabricOverlay);

            hideAlertbox();
          },
        },
      ],
    });
  };

  const handleKeyDown = useCallback(
    (e) => {
      if ((e.key === 'Delete' || e.key === 'Backspace') && activeObject) {
        e.preventDefault();
        handleDelete();
      }
    },
    [activeObject]
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  if (!activeObject) return null;

  return (
    <Button
      id='delete'
      label={__('canvas.toolbar.delete')}
      icon={DeleteIcon}
      onClick={handleDelete}
      extraClass={['withSpacer']}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    fabric_overlay: state.fabric_overlay,
  };
};

export default connect(mapStateToProps, null)(Delete);
